import { render, staticRenderFns } from "./VisitHistory.vue?vue&type=template&id=1fb3b517&"
import script from "./VisitHistory.vue?vue&type=script&lang=js&"
export * from "./VisitHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports